import { DossierShellMetricProfile } from '../create-dossier-states-definition';
import {
  DossierMetricProfile,
  dossierEconomicParticipantProfile,
  dossierEmployedProfile,
  dossierGvaProfile,
  dossierRevenueProfile,
  dossierTaxedProfile,
} from '../dossier-metric.profile';
import { DashboardDossierStatesMarketViewConfig } from './dashboard-dossier-states-market.definition';

/**
 * Market-shell metric profile: shared dossier metric core +
 * market view.
 */
export type DossierMarketMetricProfile = DossierShellMetricProfile<
  DashboardDossierStatesMarketViewConfig
>;

const valueKey = 'value';

function fromShared(
  shared: DossierMetricProfile,
  shell: {
    extraRanks?: DossierMarketMetricProfile['extraRanks'];
    view: DashboardDossierStatesMarketViewConfig;
  },
): DossierMarketMetricProfile {
  return {
    ...shared,
    ...shell,
  };
}

export const dossierMarketTaxedProfile: DossierMarketMetricProfile =
  fromShared(dossierTaxedProfile, {
    extraRanks: [
      { rankColumn: 'companies_count_rank', valueColumn: 'companies_count' },
      { rankColumn: 'small_companies_count_rank', valueColumn: 'small_companies_count' },
    ],
    view: {
      valueKey,
      categoryKey: 'sub_market_name',
      metricKey: dossierTaxedProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Anzahl ${d[dossierTaxedProfile.valueLabelKey]}`,
      valueFormat: 'number',
    },
  });

export const dossierMarketRevenueProfile: DossierMarketMetricProfile =
  fromShared(dossierRevenueProfile, {
    extraRanks: [
      { rankColumn: 'companies_revenue_rank', valueColumn: 'companies_revenue__k_eur' },
      { rankColumn: 'small_companies_revenue_rank', valueColumn: 'small_companies_revenue__k_eur' },
    ],
    view: {
      valueKey,
      categoryKey: 'sub_market_name',
      metricKey: dossierRevenueProfile.valueLabelKey,
      popupValueLabel: () => 'Teilmarkt-Umsatz',
      valueFormat: 'currency',
      marginRight: 150,
    },
  });

export const dossierMarketGvaProfile: DossierMarketMetricProfile =
  fromShared(dossierGvaProfile, {
    extraRanks: [
      { rankColumn: 'gross_value_added_rank', valueColumn: 'gross_value_added__k_eur' },
      { rankColumn: 'production_value_rank', valueColumn: 'production_value__k_eur' },
    ],
    view: {
      valueKey,
      categoryKey: 'sub_market_name',
      metricKey: dossierGvaProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Teilmarkt-${d[dossierGvaProfile.valueLabelKey] ?? dossierGvaProfile.base.labels.shortLabel}`,
      valueFormat: 'currency',
      marginRight: 150,
    },
  });

export const dossierMarketEconomicParticipantProfile: DossierMarketMetricProfile =
  fromShared(dossierEconomicParticipantProfile, {
    view: {
      valueKey,
      categoryKey: 'sub_market_name',
      metricKey: dossierEconomicParticipantProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Teilmarkt-${d[dossierEconomicParticipantProfile.valueLabelKey]}`,
      valueFormat: 'number',
      popupDetail: 'economic-participants',
    },
  });

export const dossierMarketEmployedProfile: DossierMarketMetricProfile =
  fromShared(dossierEmployedProfile, {
    view: {
      valueKey,
      categoryKey: 'sub_market_name',
      metricKey: dossierEmployedProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Teilmarkt-${d[dossierEmployedProfile.valueLabelKey]}`,
      valueFormat: 'number',
    },
  });
